// Models
import PAGINATION from './pagination';

export default {
  createdAt: '',
  email: '',
  id: null,
  isSuperAdmin: false,
  isInitialised: false,
  name: '',
  updatedAt: '',
  isAuthenticated: false,
  favourites: {
    casinos: {
      data: [],
      meta: PAGINATION,
      summary: []
    },
    games: {
      data: [],
      meta: PAGINATION,
      summary: []
    },
    offers: {
      data: [],
      meta: PAGINATION,
      summary: []
    },
    suppliers: {
      data: [],
      meta: PAGINATION,
      summary: []
    },
  },
  recentGames: []
}


// WEBPACK FOOTER //
// ./resources/assets/js/app/store/models/user.js